<template>
  <div :class="[baseClass, customClass]">
    <div>
      <div class="header">
        <h2>
          {{ $t('lps.userCardFinal.headerSlogan') }}
        </h2>
      </div>
      <div class="sub-header">
        <h4>
          {{ $t('lps.userCardFinal.headerSubSlogan') }}
        </h4>
        <p>
          {{ $t('lps.userCardFinal.headerSubSlogan2') }}
        </p>
      </div>
      <div class="profile">
        <div>
          <img
            src="@/assets/images/lps/people.png"
            alt="people"
            class="profile-image"
            @click="emit('nextCarousel')"
          >
          <img
            src="@/assets/images/logo/logo.png"
            alt="boho logo"
            style="width: calc(100% - 20px); position: absolute; left: 10px; top: 96px; opacity: 0.31"
            @click="$emit('nextCarousel')"
          >
        </div>
      </div>
      <div
        class="sub-profile"
        style="background-color: #fff;"
        @click="updateActiveStep(2)"
      >
        <img
          src="@/assets/images/lps/one-time-offer-40.png"
          alt="one-time-offer"
          class="w-100 cursor-pointer"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LpUserCard',
  props: {
    customClass: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      baseClass: null,
    }
  },
  methods: {
    updateActiveStep(step = 2) {
      this.$emit('updateActiveStep', step)
    },
  },
}
</script>
